import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ICustomApp } from '@sv/interfaces';
import { AttendeesService } from 'src/app/_services/_auth/attendees.service';
import { CustomAppService } from 'src/app/_services/_content/customApp.service';

@Component({
  selector: 'app-fogot-password-dialog',
  templateUrl: './fogot-password-dialog.component.html',
  styleUrls: ['./fogot-password-dialog.component.scss']
})
export class FogotPasswordDialogComponent implements OnInit {
  email: FormControl;
  customApp: ICustomApp;

  constructor(
    private attendeeService: AttendeesService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private customAppService: CustomAppService
  ) {}

  ngOnInit(): void {
    this.email = new FormControl('', [Validators.required, Validators.email]);
    this.customAppService.getCustomAppListener().subscribe((customApp) => {
      this.customApp = customApp;
    });
  }

  async requestPwReset() {
    try {
      await this.attendeeService.resetPasswordEmail(this.email.value, this.customApp.eventId);
      this.snackBar.open(
        'Falls ein Benutzer mit der angegebenen E-Mail-Adresse existiert, wurden Anweisungen zum Zurücksetzen des Passworts an diese Email gesendet.',
        'Schließen',
        {
          duration: 5000
        }
      );
      this.leave();
    } catch (error) {
      this.snackBar.open(`Serverfehler: ${error.error.message}`, 'Schließen', {
        duration: 3000
      });
    }
  }

  leave() {
    this.dialog.closeAll();
  }
}
